export const PRIVACY_POLICY_LINK = "/";
export const TERMS_AND_CONDITIONS_LINK = "/";
